let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jq2kJ")).then(() => parcelRequire('bn4UH'));